import { BusySpinner } from "./Busy";

export function CenteredBusySpinner() {
    return (
        <div className="k-d-flex k-justify-content-center k-align-items-center k-h-full k-w-full">
            <BusySpinner dimensions={75} />
        </div>
    );
}
